import Vue from 'vue'
import Vuex from 'vuex'
import { createStore } from 'vuex-extensions'
import modules from './modules'
Vue.use(Vuex)
export default createStore(Vuex.Store, {
  modules,
  strict: process.env.NODE_ENV === 'development'
})
